import { useMantineTheme } from "@mantine/core";

const BAR_HEIGHT = 2;
const BAR_WIDTH = 18;
const SVG_SIZE = 24;

/**
 * Custom hamburger icon with uniform line thickness. Replaces Mantine Burger
 * to fix uneven rendering of the three bars.
 */
export default function HamburgerButton({ opened, onClick, size = "lg", color = "orange", ...props }) {
  const theme = useMantineTheme();
  const resolvedColor =
    theme.colors?.[color]?.[6] ??
    (color === "dark" ? theme.colors?.gray?.[9] : theme.colors?.orange?.[6]) ??
    "#1a1a1a";

  const sizeMap = { xs: 28, sm: 32, md: 36, lg: 40, xl: 44 };
  const px = typeof size === "number" ? size : sizeMap[size] ?? 40;

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={opened ? "Close menu" : "Open menu"}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: px,
        height: px,
        padding: 0,
        border: "none",
        background: "transparent",
        cursor: "pointer",
      }}
      {...props}
    >
      <svg
        width={SVG_SIZE}
        height={SVG_SIZE}
        viewBox={`0 0 ${SVG_SIZE} ${SVG_SIZE}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: "block" }}
      >
        {opened ? (
          <g stroke={resolvedColor} strokeWidth={BAR_HEIGHT} strokeLinecap="round">
            <line x1={4} y1={4} x2={20} y2={20} />
            <line x1={20} y1={4} x2={4} y2={20} />
          </g>
        ) : (
          <g fill={resolvedColor}>
            <rect
              x={(SVG_SIZE - BAR_WIDTH) / 2}
              y={5}
              width={BAR_WIDTH}
              height={BAR_HEIGHT}
              rx={1}
            />
            <rect
              x={(SVG_SIZE - BAR_WIDTH) / 2}
              y={11}
              width={BAR_WIDTH}
              height={BAR_HEIGHT}
              rx={1}
            />
            <rect
              x={(SVG_SIZE - BAR_WIDTH) / 2}
              y={17}
              width={BAR_WIDTH}
              height={BAR_HEIGHT}
              rx={1}
            />
          </g>
        )}
      </svg>
    </button>
  );
}
